<!-- this is webkit news-->
<!--buttons colors from this file are placed in _buttons.scss it is hard coded and it has to be changed-->


<template>
  <div class="webkit-webcamBanner-container">


      <div class="webkit-webcamBanner-grid">
          <h2 class="webkit-webcamBanner-title" v-html="heading"> </h2>
     </div>

      <div class="webkit-webcamBanner-grid" >
        <CoolLightBox 
          :items="items" 
          :index="index"
          @close="index = null">
        </CoolLightBox>
        
        <div v-for="(webcam, imageIndex) in blocks"
            :key="imageIndex"
            @click="index = imageIndex">
         
            <div class="webkit-webcamBanner-image h-60 cursor-pointer bg-center bg-cover"  :style="{ backgroundImage: 'url(' + webcam.img + ')' }"></div>
            <div class="webkit-webcam-heading"   v-html="webcam.heading"></div>
        </div>

      </div>
        
      

  </div>
</template>

<script>
import Vue, { VNode } from 'vue';
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

Vue.use(CoolLightBox)

export default Vue.extend({
  name: 'WebkitWebcams',
  props: {
        blocks: Array,
        heading:String,
  },
  data() {
    return {
      items: [],
      index: null,
      displayedBlocks: [],
      activeFilter: ""
    };
  },
  mounted() { 
    this.mergeItems();
  },
  methods: {
    mergeItems: function () {
      this.blocks.forEach(element => {
        this.items.push(element.img);
      }); 
    },
  },
    
});
</script> 



 <!--<template>
    <div class="main-grid-structure">
      <div class="webkit-grid-container-cell ">
        
      
            <div class="existence" v-html="heading"></div>
            <div v-html="blocks.heading"></div>
            <img class="w-1/3 cursor-pointer" src="https://th.bing.com/th/id/R.a62780a122e270a936c1751c3e0acd47?rik=HmVzbNd00%2by5cg&riu=http%3a%2f%2fsciences-ingenieur.genevoix-signoret-vinci.fr%2fSNT%2f2-web%2fres%2furl.jpg&ehk=PzfpjNdQS%2biHLEzKxxx81LRqHhG%2fLTmPkmBSzx3ONVk%3d&risl=&pid=ImgRaw" alt="">
        </div>
    </div>
</template>

<script>
import Vue, { VNode } from 'vue';


export default Vue.extend({
  name: 'WebkitWebcams',
  props: {
    blocks: Array,
    heading:String,
  },
  data() {
    return {
      displayedBlocks: [],
      activeFilter: ""
    };
  },
    
});
</script>-->
